import React from 'react';
import { Card, CardContent } from './ui/card';
import Navigation from './Navigation';
import Footer from './Footer';
import { charterStatement, quickFacts, newsUpdates } from '../mock';

const AboutPage = () => {
  return (
    <div className="page-container">
      <Navigation />
      
      <main className="main-content">
        <section className="page-hero">
          <div className="container">
            <h1 className="page-title">About Us</h1>
            <p className="page-subtitle">Building Champions On and Off the Field Since 1979</p>
          </div>
        </section>

        {/* Charter Statement */}
        <section className="charter-section">
          <div className="container">
            <div className="charter-statement">
              <h2>Our Mission</h2>
              <p>{charterStatement.mission}</p>
            </div>
          </div>
        </section>

        {/* Core Values */}
        <section className="values-section">
          <div className="container">
            <h2 className="section-title">Our Core Values</h2>
            <div className="values-grid">
              {charterStatement.coreValues && charterStatement.coreValues.map((value) => (
                <Card key={value.id} className="value-card">
                  <CardContent>
                    <h3>{value.title}</h3>
                    <p>{value.description}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>

        {/* Quick Facts */}
        <section className="facts-section">
          <div className="container">
            <h2 className="section-title">Quick Facts</h2>
            
            <div className="facts-categories">
              {/* About Facts */}
              <div className="facts-category">
                <h3>About Us</h3>
                <ul className="facts-list">
                  {quickFacts.about.map((fact) => (
                    <li key={fact}>{fact}</li>
                  ))}
                </ul>
              </div>

              {/* Programs Facts */}
              <div className="facts-category">
                <h3>Our Programs</h3>
                <div className="programs-facts">
                  {quickFacts.programs.map((program) => (
                    <div key={program.name} className="program-fact">
                      <span className="program-name">{program.name}</span>
                      <span className="program-ages">{program.ages}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Coaching Facts */}
              <div className="facts-category">
                <h3>Coaching Staff</h3>
                <ul className="facts-list">
                  {quickFacts.coaching.map((fact) => (
                    <li key={fact}>{fact}</li>
                  ))}
                </ul>
              </div>

              {/* Game Info */}
              <div className="facts-category">
                <h3>Game Information</h3>
                <div className="game-facts">
                  <p><strong>Home Games:</strong> {quickFacts.gameInfo.home}</p>
                  <p><strong>Away Games:</strong> {quickFacts.gameInfo.away}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* News Section */}
        <section className="news-section">
          <div className="container">
            <h2 className="section-title">Latest News & Updates</h2>
            <div className="news-grid">
              {newsUpdates.map((news) => (
                <Card key={news.id} className="news-card">
                  <CardContent>
                    <span className="news-date">{news.date}</span>
                    <h3 className="news-title">{news.title}</h3>
                    <p className="news-content">{news.content}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>

        {/* Promo Image */}
        <section className="promo-section">
          <div className="container">
            <div className="promo-image-wrapper">
              <img 
                src="https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/s03eaq7d_2026%20QR%20CODE%20flyer.png" 
                alt="Randallstown Panthers 2026 Registration" 
                className="promo-image"
              />
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AboutPage;
